import { isSuperUserSessionTransfer } from "@pathwright/utils/src/token/utils"
import { getPWAdminSSOOptions } from "@pathwright/auth/src/views/auth/utils/getPWAdminSSOUrl"
import { useMemo } from "react"
import { usePathwrightContext } from "../pathwright/PathwrightContext"
import { usePWAdminCmdKContext } from "./PWAdminCmdKContext"

// Only enable for users with stored SSO options (which in practice should
// be limited to pw super users). Or, super users (proxied or not).
export function getIsPWAdminUtilEnabled() {
  return isSuperUserSessionTransfer() || !!getPWAdminSSOOptions().length
}

export function useIsPWAdminUtilEnabled() {
  // Fallback to this check.
  const { pwAdminEnabled } = usePWAdminCmdKContext()

  // Need to reassess if the toolbar is enabled based on context (current user).
  const { me } = usePathwrightContext()
  return useMemo(() => getIsPWAdminUtilEnabled(), [me?.id]) || pwAdminEnabled
}

export default useIsPWAdminUtilEnabled
